import { types } from "../types/types";

const initial = {
  elAguilaLista: [],
  elAguilaPoliza: {},
  chubbPoliza: null,
  clienteID: "",
  loadingPolizario: false,
  vistaResultados: 0, // 0 sin busqueda, 1 lista, 2 detalle
  qualitasResponse: {},
  gsegurosResponse: {},
  gsegurosEmision: {},
  loadingGSeguros: false,
  vistaGSeguros: 0, // 0 sin busqueda/error, 1 lista, 2 detalle
  edegaContrato: {},
  edegaDetalleReclamo: {},
  loadingEdega: false,
  vistaEdega: 0,
  
};
export const polizarioReducer = (state = initial, action) => {
  switch (action.type) {
    case types.setQualitasResponse:
      return {
        ...state,
        qualitasResponse: action.payload,
      };
    case types.setVistaResultados:
      return {
        ...state,
        vistaResultados: action.payload,
      };
    case types.setLoadingPolizario:
      return {
        ...state,
        loadingPolizario: action.payload,
      };
    case types.setClienteID:
      return {
        ...state,
        clienteID: action.payload,
      };

    case types.storeElAguilaPoliza:
      return {
        ...state,
        elAguilaPoliza: action.payload,
      };
    case types.storeChubbPoliza:
      return {
        ...state,
        chubbPoliza: action.payload,
      };
    case types.storeElAguilaLista:
      return {
        ...state,
        elAguilaLista: action.payload,
      };
    // GSeguros cases
    case types.setGSegurosResponse:
      return {
        ...state,
        gsegurosResponse: action.payload,
      };
    case types.setGSegurosEmision:
      return {
        ...state,
        gsegurosEmision: action.payload,
      };
    case types.setLoadingGSeguros:
      return {
        ...state,
        loadingGSeguros: action.payload,
      };
    case types.setVistaGSeguros:
      return {
        ...state,
        vistaGSeguros: action.payload,
      };
    case types.cleanGSegurosEmision:
      return {
        ...state,
        gsegurosResponse: {},
        gsegurosEmision: {},
        vistaGSeguros: 0,
      };
    case types.setEdegaContrato:
      return {
        ...state,
        edegaContrato: action.payload,
      };
    case types.setEdegaDetalleReclamo:
      return {
        ...state,
        edegaDetalleReclamo: action.payload,
      };
    case types.setLoadingEdega:
      return {
        ...state,
        loadingEdega: action.payload,
      };
    case types.setVistaEdega:
      return {
        ...state,
        vistaEdega: action.payload,
      };
    case types.cleanPolizario:
      return {
        ...state,
        elAguilaLista: [],
        elAguilaPoliza: {},
        chubbPoliza: null,
        loadingPolizario: false,
        vistaResultados: 0,
        gsegurosResponse: {},
        gsegurosEmision: {},
        loadingGSeguros: false,
        vistaGSeguros: 0,
        edegaContrato: {},
        edegaDetalleReclamo: {},
        loadingEdega: false,
        vistaEdega: 0,
      };

    default:
      return state;
  }
};
